import { input } from '../../Commons/input';
import { button } from '../../Commons/button';
import { media, palette } from '../../theme';

export const addReasonModal = {
  title: {
    gridArea: 'a',
    justifySelf: 'center',
    fontFamily: 'Roboto',
    fontWeight: 500,
    textAlign: 'center',
    [media.desktop]: {
      margin: '3rem 0 2rem 0',
      fontSize: '1.375rem',
    },
  },
  form: {
    gridArea: 'b',
    display: 'flex',
    flexWrap: 'wrap',
    margin: '20px auto 0',
    [media.desktop]: {
      width: '70%',
    },
  },
  inputError: { ...input.error },
  backError: {
    width: '100%',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: '300',
    color: 'red',
  },
  submit: {
    ...button.yellow,
    margin: '2rem auto 2rem auto',
    backgroundColor: palette.blue,
    border: `1px solid ${palette.blue}`,
    width: '45%',
  },
  cancel: {
    ...button.yellow,
    width: '45%',
    margin: '2rem auto 2rem auto',
    backgroundColor: palette.grey500,
    border: `1px solid ${palette.grey500}`,
  },
  textarea: {
    ...input.input,
    padding: '0.5rem',
    resize: 'none',
    '&::placeholder': {
      color: '#a9a9a9',
    },
    '&:focus': {
      outline: 'none',
      borderColor: palette.black,
    },
  },
  textareaContainer: {
    ...input.container,
    [media.mobile]: {
      height: '10rem',
      gridTemplateRows: '2.25rem auto 1.75rem',
    },
    [media.desktop]: {
      ...input.container[media.desktop],
      height: '8rem',
      gridTemplateColumns: '7.5rem auto',
      gridTemplateRows: '2.25rem auto 1.75rem',
      gridTemplateAreas: `
      'b b'
      'b b'
      '. c'
      `,
    },
  },
};

